import { useContext, useEffect, useRef, useState } from "react";
import ActionCard from "./ActionCard";
import "./Actions.css";
import { Context } from "../../../../context/Context";
import { translations } from "../../../../utils/lang";
import { fetchActionsAPI } from "../../../../utils/api/actions";

// The status list of a store/app. New campaigns are created from the Campaign
// Actions box at the top of the Operation page, not from here.
export default function Actions({ storeId, appName, refreshKey, onRefresh }) {
  const { lang, handleTokenExpiration } = useContext(Context);

  const [actions, setActions] = useState([]);
  const tokenExpiredRef = useRef(handleTokenExpiration);
  tokenExpiredRef.current = handleTokenExpiration;

  useEffect(() => {
    let active = true;
    const token = localStorage.getItem("auth-token");
    if (!token) {
      tokenExpiredRef.current();
      return undefined;
    }

    fetchActionsAPI(token, { storeId, appName }).then((actionsData) => {
      // Ignore responses for a previous store/app or refresh.
      if (!active) return;
      if (actionsData) {
        setActions(actionsData);
      } else {
        // Existing behaviour: the helper can't tell an expired session from
        // other failures, and this list treats a failure as expiry.
        tokenExpiredRef.current();
      }
    });

    return () => {
      active = false;
    };
  }, [storeId, appName, refreshKey]);

  return (
    <div className="actions-card">
      <div className="actions-header">
        <h3>{translations[lang].Operation.actionTitle}</h3>
      </div>

      <div className="actions-list">
        {actions.map((action, i) => (
          <ActionCard
            // Keyed by id so per-card state (e.g. an open confirm dialog)
            // stays with its action when the list reorders after a refresh.
            key={action._id || i}
            action={action}
            storeId={storeId}
            showAppIndicator={appName === "LUD"}
            onRefresh={onRefresh}
          />
        ))}
      </div>
    </div>
  );
}
